export default __webpack_public_path__ + "static/media/image-ph-study-report-n-m@2x.34a36df6.webp";